type ClosestElementTarget = EventTarget & {
  closest?: (selector: string) => Element | null;
};

export function dismissProfilePopoverFromOutsidePointer(
  profileOpen: boolean,
  target: EventTarget | null,
  onDismiss: () => void,
) {
  if (!profileOpen) return;
  const closest = (target as ClosestElementTarget | null)?.closest;
  if (typeof closest === "function" && closest.call(target, ".profile-anchor")) return;
  onDismiss();
}
